export class FavouriteService {
	constructor($http, $q, $timeout) {
		'ngInject';
		this.$http = $http;
		this.$q = $q;
		this.$timeout = $timeout;
		this.publicRoot = '/public';
		this.privateRoot = '/private';
	}

	getFavourites(params) {
		return this.$http({
			method: 'GET',
			url: `${this.privateRoot}/favourites`,
			params: params
		});
	}

	getSoldFavourites() {
		return this.$http({
			method: 'GET',
			url: `${this.privateRoot}/favourites/sold`
		});
	}

	/**
	 * @param params {comment: "string"}
	 * @param favouriteId
	 */
	saveComment(params, id) {
		return this.$http({
			method: 'PUT',
			url: `${this.privateRoot}/favourites/${id}`,
			data: params
		});
	}

	/**
	 * @param comissionId
	 */
	setFavourite(id) {
		return this.$http({
			method: 'POST',
			url: `${this.privateRoot}/favourites/${id}`
		});
	}

	deleteAll() {
		return this.$http({
			method: 'DELETE',
			url: `${this.privateRoot}/favourites`
		});
	}

	/**
	 * @param params {comissionIds: [M001, M345, ...]}
	 */
	deleteItem(id) {
		return this.$http({
			method: 'DELETE',
			url: `${this.privateRoot}/favourites/${id}`
		});
	}

	deleteSome(params) {
		return this.$http({
			method: 'DELETE',
			url: `${this.privateRoot}/favourites/some`,
			params: params
		});
	}
}
